<p-modal-confirm
    [title]="'Usuario no autorizado'"
    [icon]="'warning'"
    [subtitle]="'Parece que no cuentas con permiso para ejecutar esta acción. Si crees que se trata de un error, por favor comunícate con soporte.'"
    [titleButton]="'Entendido'"
    [isVisible]="true"
></p-modal-confirm>
